import * as api from '../api/electronicRequest';
import { makeApiActionCreatorV3 } from '@actions/utils';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';

const namespace = 'APPRAISAL/ELECTRONICREQUEST';

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;
export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;
export const CHANGE_FILTER = `${namespace}/CHANGE_FILTER`;

export const CHANGE_PAGE_AGENT = `${namespace}/CHANGE_PAGE_AGENT`;
export const CHANGE_ROWS_PER_PAGE_AGENT = `${namespace}/CHANGE_ROWS_PER_PAGE_AGENT`;
export const CHANGE_FILTER_AGENT = `${namespace}/CHANGE_FILTER_AGENT`;

export const ELECTRONIC_REQUEST_SEARCH_STANDALONE = createRequestTypes(
  `${namespace}/ELECTRONIC_REQUEST_SEARCH_STANDALONE`,
);

export const searchElectronicRequestsStandalone = makeApiActionCreatorV3(
  api.searchElectronicRequests,
  ELECTRONIC_REQUEST_SEARCH_STANDALONE[START],
  ELECTRONIC_REQUEST_SEARCH_STANDALONE[SUCCESS],
  ELECTRONIC_REQUEST_SEARCH_STANDALONE[ERROR],
);

export const ELECTRONIC_REQUEST_SEARCH = createRequestTypes(
  `${namespace}/ELECTRONIC_REQUEST_SEARCH`,
);

export const searchElectronicRequests = makeApiActionCreatorV3(
  api.searchElectronicRequests,
  ELECTRONIC_REQUEST_SEARCH[START],
  ELECTRONIC_REQUEST_SEARCH[SUCCESS],
  ELECTRONIC_REQUEST_SEARCH[ERROR],
);

export const ELECTRONIC_REQUEST_AGENT_SEARCH = createRequestTypes(
  `${namespace}/ELECTRONIC_REQUEST_AGENT_SEARCH`,
);

export const searchElectronicRequestsAgent = makeApiActionCreatorV3(
  api.searchElectronicRequestsAgent,
  ELECTRONIC_REQUEST_AGENT_SEARCH[START],
  ELECTRONIC_REQUEST_AGENT_SEARCH[SUCCESS],
  ELECTRONIC_REQUEST_AGENT_SEARCH[ERROR],
);

export const FETCH_ELECTRONIC_REQUEST_STATUS_CODES = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_REQUEST_STATUS_CODES`,
);

export const fetchElectronicRequestStatusCodes = makeApiActionCreatorV3(
  api.fetchElectronicRequestStatusCodes,
  FETCH_ELECTRONIC_REQUEST_STATUS_CODES[START],
  FETCH_ELECTRONIC_REQUEST_STATUS_CODES[SUCCESS],
  FETCH_ELECTRONIC_REQUEST_STATUS_CODES[ERROR],
);

export const FETCH_ELECTRONIC_REQUEST_STATUS_CONFIGS = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_REQUEST_STATUS_CONFIGS`,
);

export const fetchElectronicRequestStatusConfigs = makeApiActionCreatorV3(
  api.fetchElectronicRequestStatusConfigs,
  FETCH_ELECTRONIC_REQUEST_STATUS_CONFIGS[START],
  FETCH_ELECTRONIC_REQUEST_STATUS_CONFIGS[SUCCESS],
  FETCH_ELECTRONIC_REQUEST_STATUS_CONFIGS[ERROR],
);

export const FETCH_ELECTRONIC_REQUEST_OWNERS = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_REQUEST_OWNERS`,
);

export const fetchElectronicRequestOwners = makeApiActionCreatorV3(
  api.fetchElectronicRequestOwners,
  FETCH_ELECTRONIC_REQUEST_OWNERS[START],
  FETCH_ELECTRONIC_REQUEST_OWNERS[SUCCESS],
  FETCH_ELECTRONIC_REQUEST_OWNERS[ERROR],
);

export const UPDATE_ELECTRONIC_REQUEST_OWNER = createRequestTypes(
  `${namespace}/UPDATE_ELECTRONIC_REQUEST_OWNER`,
);

export const updateElectronicRequestOwner = makeApiActionCreatorV3(
  api.updateElectronicRequestOwner,
  UPDATE_ELECTRONIC_REQUEST_OWNER[START],
  UPDATE_ELECTRONIC_REQUEST_OWNER[SUCCESS],
  UPDATE_ELECTRONIC_REQUEST_OWNER[ERROR],
);

export const FETCH_ELECTRONIC_REQUEST_METHODS = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_REQUEST_METHODS`,
);

export const fetchElectronicRequestMethods = makeApiActionCreatorV3(
  api.fetchElectronicRequestMethods,
  FETCH_ELECTRONIC_REQUEST_METHODS[START],
  FETCH_ELECTRONIC_REQUEST_METHODS[SUCCESS],
  FETCH_ELECTRONIC_REQUEST_METHODS[ERROR],
);

export const FETCH_ELECTRONIC_REQUEST_DETAIL = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_REQUEST_DETAIL`,
);

export const fetchElectronicRequestDetail = makeApiActionCreatorV3(
  api.fetchElectronicRequestDetail,
  FETCH_ELECTRONIC_REQUEST_DETAIL[START],
  FETCH_ELECTRONIC_REQUEST_DETAIL[SUCCESS],
  FETCH_ELECTRONIC_REQUEST_DETAIL[ERROR],
);

export const FETCH_ELECTRONIC_REQUEST_DETAIL_AGENT = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_REQUEST_DETAIL_AGENT`,
);

export const fetchElectronicRequestDetailAgent = makeApiActionCreatorV3(
  api.fetchElectronicRequestDetailAgent,
  FETCH_ELECTRONIC_REQUEST_DETAIL_AGENT[START],
  FETCH_ELECTRONIC_REQUEST_DETAIL_AGENT[SUCCESS],
  FETCH_ELECTRONIC_REQUEST_DETAIL_AGENT[ERROR],
);

export const INSERT_ELECTRONIC_REQUEST = createRequestTypes(
  `${namespace}/INSERT_ELECTRONIC_REQUEST`,
);

export const insertElectronicRequest = makeApiActionCreatorV3(
  api.insertElectronicRequest,
  INSERT_ELECTRONIC_REQUEST[START],
  INSERT_ELECTRONIC_REQUEST[SUCCESS],
  INSERT_ELECTRONIC_REQUEST[ERROR],
);

export const INSERT_ELECTRONIC_REQUEST_AGENT = createRequestTypes(
  `${namespace}/INSERT_ELECTRONIC_REQUEST_AGENT`,
);

export const insertElectronicRequestAgent = makeApiActionCreatorV3(
  api.insertElectronicRequestAgent,
  INSERT_ELECTRONIC_REQUEST_AGENT[START],
  INSERT_ELECTRONIC_REQUEST_AGENT[SUCCESS],
  INSERT_ELECTRONIC_REQUEST_AGENT[ERROR],
);

export const UPDATE_ELECTRONIC_REQUEST = createRequestTypes(
  `${namespace}/UPDATE_ELECTRONIC_REQUEST`,
);

export const updateElectronicRequest = makeApiActionCreatorV3(
  api.updateElectronicRequest,
  UPDATE_ELECTRONIC_REQUEST[START],
  UPDATE_ELECTRONIC_REQUEST[SUCCESS],
  UPDATE_ELECTRONIC_REQUEST[ERROR],
);

export const UPDATE_ELECTRONIC_REQUEST_AGENT = createRequestTypes(
  `${namespace}/UPDATE_ELECTRONIC_REQUEST_AGENT`,
);

export const updateElectronicRequestAgent = makeApiActionCreatorV3(
  api.updateElectronicRequestAgent,
  UPDATE_ELECTRONIC_REQUEST_AGENT[START],
  UPDATE_ELECTRONIC_REQUEST_AGENT[SUCCESS],
  UPDATE_ELECTRONIC_REQUEST_AGENT[ERROR],
);

export const FINALIZE_ELECTRONIC_REQUEST = createRequestTypes(
  `${namespace}/FINALIZE_ELECTRONIC_REQUEST`,
);

export const finalizeElectronicRequest = makeApiActionCreatorV3(
  api.finalizeElectronicRequest,
  FINALIZE_ELECTRONIC_REQUEST[START],
  FINALIZE_ELECTRONIC_REQUEST[SUCCESS],
  FINALIZE_ELECTRONIC_REQUEST[ERROR],
);

export const REOPEN_ELECTRONIC_REQUEST = createRequestTypes(
  `${namespace}/REOPEN_ELECTRONIC_REQUEST`,
);

export const reopenElectronicRequest = makeApiActionCreatorV3(
  api.reopenElectronicRequest,
  REOPEN_ELECTRONIC_REQUEST[START],
  REOPEN_ELECTRONIC_REQUEST[SUCCESS],
  REOPEN_ELECTRONIC_REQUEST[ERROR],
);

export const INSERT_ELECTRONIC_REQUEST_FILES = createRequestTypes(
  `${namespace}/INSERT_ELECTRONIC_REQUEST_FILES`,
);

export const insertElectronicRequestFiles = makeApiActionCreatorV3(
  api.insertElectronicRequestFiles,
  INSERT_ELECTRONIC_REQUEST_FILES[START],
  INSERT_ELECTRONIC_REQUEST_FILES[SUCCESS],
  INSERT_ELECTRONIC_REQUEST_FILES[ERROR],
);

export const INSERT_ELECTRONIC_REQUEST_FILES_AGENT = createRequestTypes(
  `${namespace}/INSERT_ELECTRONIC_REQUEST_FILES_AGENT`,
);

export const insertElectronicRequestFilesAgent = makeApiActionCreatorV3(
  api.insertElectronicRequestFilesAgent,
  INSERT_ELECTRONIC_REQUEST_FILES_AGENT[START],
  INSERT_ELECTRONIC_REQUEST_FILES_AGENT[SUCCESS],
  INSERT_ELECTRONIC_REQUEST_FILES_AGENT[ERROR],
);

export const UPDATE_ELECTRONIC_REQUEST_FILES = createRequestTypes(
  `${namespace}/UPDATE_ELECTRONIC_REQUEST_FILES`,
);

export const updateElectronicRequestFiles = makeApiActionCreatorV3(
  api.updateElectronicRequestFiles,
  UPDATE_ELECTRONIC_REQUEST_FILES[START],
  UPDATE_ELECTRONIC_REQUEST_FILES[SUCCESS],
  UPDATE_ELECTRONIC_REQUEST_FILES[ERROR],
);

export const UPDATE_ELECTRONIC_REQUEST_FILES_AGENT = createRequestTypes(
  `${namespace}/UPDATE_ELECTRONIC_REQUEST_FILES_AGENT`,
);

export const updateElectronicRequestFilesAgent = makeApiActionCreatorV3(
  api.updateElectronicRequestFilesAgent,
  UPDATE_ELECTRONIC_REQUEST_FILES_AGENT[START],
  UPDATE_ELECTRONIC_REQUEST_FILES_AGENT[SUCCESS],
  UPDATE_ELECTRONIC_REQUEST_FILES_AGENT[ERROR],
);

export const GET_ELECTRONIC_REQUEST_FILE = createRequestTypes(
  `${namespace}/GET_ELECTRONIC_REQUEST_FILE`,
);

export const getElectronicRequestFile = makeApiActionCreatorV3(
  api.getElectronicRequestFile,
  GET_ELECTRONIC_REQUEST_FILE[START],
  GET_ELECTRONIC_REQUEST_FILE[SUCCESS],
  GET_ELECTRONIC_REQUEST_FILE[ERROR],
);

export const DELETE_ELECTRONIC_REQUEST_FILE = createRequestTypes(
  `${namespace}/DELETE_ELECTRONIC_REQUEST_FILE`,
);

export const deleteElectronicRequestFile = makeApiActionCreatorV3(
  api.deleteElectronicRequestFile,
  DELETE_ELECTRONIC_REQUEST_FILE[START],
  DELETE_ELECTRONIC_REQUEST_FILE[SUCCESS],
  DELETE_ELECTRONIC_REQUEST_FILE[ERROR],
);

export const DELETE_ELECTRONIC_REQUEST_FILE_AGENT = createRequestTypes(
  `${namespace}/DELETE_ELECTRONIC_REQUEST_FILE_AGENT`,
);

export const deleteElectronicRequestFileAgent = makeApiActionCreatorV3(
  api.deleteElectronicRequestFileAgent,
  DELETE_ELECTRONIC_REQUEST_FILE_AGENT[START],
  DELETE_ELECTRONIC_REQUEST_FILE_AGENT[SUCCESS],
  DELETE_ELECTRONIC_REQUEST_FILE_AGENT[ERROR],
);

export const FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS`,
);

export const fetchElectronicRequestNotifications = makeApiActionCreatorV3(
  api.fetchElectronicRequestNotifications,
  FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS[START],
  FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS[SUCCESS],
  FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS[ERROR],
);

export const FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS_AGENT = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS_AGENT`,
);

export const fetchElectronicRequestNotificationsAgent = makeApiActionCreatorV3(
  api.fetchElectronicRequestNotificationsAgent,
  FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS_AGENT[START],
  FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS_AGENT[SUCCESS],
  FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS_AGENT[ERROR],
);

export const FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS_AGENT_APPEALS = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS_AGENT_APPEALS`,
);

export const fetchElectronicRequestNotificationsAgentAppeals = makeApiActionCreatorV3(
  api.fetchElectronicRequestNotificationsAgentAppeals,
  FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS_AGENT_APPEALS[START],
  FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS_AGENT_APPEALS[SUCCESS],
  FETCH_ELECTRONIC_REQUEST_NOTIFICATIONS_AGENT_APPEALS[ERROR],
);

export const FETCH_ELECTRONIC_REQUEST_NOTIFICATION_DETAILS_AGENT = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_REQUEST_NOTIFICATION_DETAILS_AGENT`,
);

export const fetchElectronicRequestNotificationDetailsAgent = makeApiActionCreatorV3(
  api.fetchElectronicRequestNotificationDetailsAgent,
  FETCH_ELECTRONIC_REQUEST_NOTIFICATION_DETAILS_AGENT[START],
  FETCH_ELECTRONIC_REQUEST_NOTIFICATION_DETAILS_AGENT[SUCCESS],
  FETCH_ELECTRONIC_REQUEST_NOTIFICATION_DETAILS_AGENT[ERROR],
);

export const FETCH_ELECTRONIC_REQUEST_REVISION_HISTORY = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_REQUEST_REVISION_HISTORY`,
);

export const fetchElectronicRequestRevisionHistory = makeApiActionCreatorV3(
  api.fetchElectronicRequestRevisionHistory,
  FETCH_ELECTRONIC_REQUEST_REVISION_HISTORY[START],
  FETCH_ELECTRONIC_REQUEST_REVISION_HISTORY[SUCCESS],
  FETCH_ELECTRONIC_REQUEST_REVISION_HISTORY[ERROR],
);

export const FETCH_ELECTRONIC_REQUEST_REVISION_HISTORY_AGENT = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_REQUEST_REVISION_HISTORY_AGENT`,
);

export const fetchElectronicRequestRevisionHistoryAgent = makeApiActionCreatorV3(
  api.fetchElectronicRequestRevisionHistoryAgent,
  FETCH_ELECTRONIC_REQUEST_REVISION_HISTORY_AGENT[START],
  FETCH_ELECTRONIC_REQUEST_REVISION_HISTORY_AGENT[SUCCESS],
  FETCH_ELECTRONIC_REQUEST_REVISION_HISTORY_AGENT[ERROR],
);

export const RESCIND_ELECTRONIC_REQUEST_AGENT = createRequestTypes(
  `${namespace}/RESCIND_ELECTRONIC_REQUEST_AGENT`,
);

export const rescindElectronicRequestAgent = makeApiActionCreatorV3(
  api.rescindElectronicRequestAgent,
  RESCIND_ELECTRONIC_REQUEST_AGENT[START],
  RESCIND_ELECTRONIC_REQUEST_AGENT[SUCCESS],
  RESCIND_ELECTRONIC_REQUEST_AGENT[ERROR],
);

export const MASS_FINALIZE_ELECTRONIC_REQUESTS = createRequestTypes(
  `${namespace}/MASS_FINALIZE_ELECTRONIC_REQUESTS`,
);

export const massFinalizeElectronicRequests = makeApiActionCreatorV3(
  api.massFinalizeElectronicRequests,
  MASS_FINALIZE_ELECTRONIC_REQUESTS[START],
  MASS_FINALIZE_ELECTRONIC_REQUESTS[SUCCESS],
  MASS_FINALIZE_ELECTRONIC_REQUESTS[ERROR],
);

export const MASS_RESCIND_ELECTRONIC_REQUESTS = createRequestTypes(
  `${namespace}/MASS_RESCIND_ELECTRONIC_REQUESTS`,
);

export const massRescindElectronicRequests = makeApiActionCreatorV3(
  api.massRescindElectronicRequests,
  MASS_RESCIND_ELECTRONIC_REQUESTS[START],
  MASS_RESCIND_ELECTRONIC_REQUESTS[SUCCESS],
  MASS_RESCIND_ELECTRONIC_REQUESTS[ERROR],
);

export const FETCH_ELECTRONIC_DELIVERY_NOTIFICATIONS = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_DELIVERY_NOTIFICATIONS`
);

export const fetchElectronicDeliveryNotifications = makeApiActionCreatorV3(
  api.fetchElectronicDeliveryNotifications,
  FETCH_ELECTRONIC_DELIVERY_NOTIFICATIONS[START],
  FETCH_ELECTRONIC_DELIVERY_NOTIFICATIONS[SUCCESS],
  FETCH_ELECTRONIC_DELIVERY_NOTIFICATIONS[ERROR]
);

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const changePageAgent = page => ({
  type: CHANGE_PAGE_AGENT,
  payload: page,
});

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const changeRowsPerPageAgent = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE_AGENT,
  payload: rowsPerPage,
});

export const changeFilter = filter => ({
  type: CHANGE_FILTER,
  payload: filter,
});

export const changeFilterAgent = filter => ({
  type: CHANGE_FILTER_AGENT,
  payload: filter,
});
